import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=20cc728c&scoped=true&"
import script from "./Cadastro.vue?vue&type=script&lang=js&"
export * from "./Cadastro.vue?vue&type=script&lang=js&"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=20cc728c&lang=scss&scoped=true&"
import style1 from "./Cadastro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc728c",
  null
  
)

export default component.exports